// src/components/financial/TransactionHistory.js
import React, { useState } from 'react';

function TransactionHistory({ expenses, payments, month, year }) {
  const [filter, setFilter] = useState('all');
  
  // Combine and sort transactions
  const transactions = [
    ...payments.map(p => ({
      ...p,
      type: 'income',
      date: p.payment_date,
      description: `Payment from Flat ${p.flat_number}`,
      displayAmount: p.amount
    })),
    ...expenses.map(e => ({
      ...e,
      type: 'expense',
      date: e.expense_date,
      description: e.title,
      displayAmount: e.amount
    }))
  ].sort((a, b) => new Date(b.date) - new Date(a.date));

  const filteredTransactions = filter === 'all' 
    ? transactions 
    : transactions.filter(t => t.type === filter);

  const totalIncome = payments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);
  const totalExpense = expenses.reduce((sum, e) => sum + parseFloat(e.amount || 0), 0);
  const netBalance = totalIncome - totalExpense;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3>Transaction History</h3>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={() => setFilter('all')}
            style={{
              padding: '8px 16px',
              background: filter === 'all' ? '#667eea' : '#e9ecef',
              color: filter === 'all' ? 'white' : '#666',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            All
          </button>
          <button
            onClick={() => setFilter('income')}
            style={{
              padding: '8px 16px',
              background: filter === 'income' ? '#28a745' : '#e9ecef',
              color: filter === 'income' ? 'white' : '#666',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Income
          </button>
          <button
            onClick={() => setFilter('expense')}
            style={{
              padding: '8px 16px',
              background: filter === 'expense' ? '#dc3545' : '#e9ecef',
              color: filter === 'expense' ? 'white' : '#666',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Expenses
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '20px' }}>
        <div style={{
          padding: '15px',
          background: '#d4edda',
          borderRadius: '8px',
          borderLeft: '4px solid #28a745'
        }}>
          <div style={{ fontSize: '12px', color: '#155724', marginBottom: '5px' }}>Total Income</div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#155724' }}>
            +₹{totalIncome.toFixed(2)}
          </div>
        </div>
        
        <div style={{
          padding: '15px',
          background: '#f8d7da',
          borderRadius: '8px',
          borderLeft: '4px solid #dc3545'
        }}>
          <div style={{ fontSize: '12px', color: '#721c24', marginBottom: '5px' }}>Total Expenses</div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#721c24' }}>
            -₹{totalExpense.toFixed(2)}
          </div>
        </div>
        
        <div style={{
          padding: '15px',
          background: netBalance >= 0 ? '#cfe2ff' : '#fff3cd',
          borderRadius: '8px',
          borderLeft: `4px solid ${netBalance >= 0 ? '#0d6efd' : '#ffc107'}`
        }}>
          <div style={{ fontSize: '12px', color: '#333', marginBottom: '5px' }}>Net Balance</div>
          <div style={{ 
            fontSize: '20px', 
            fontWeight: 'bold', 
            color: netBalance >= 0 ? '#0d6efd' : '#856404' 
          }}>
            {netBalance >= 0 ? '+' : ''}₹{netBalance.toFixed(2)}
          </div>
        </div>
      </div>

      {/* Transaction List */}
      <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '15px' }}>
        {filteredTransactions.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#666' }}>No transactions found</p>
        ) : (
          filteredTransactions.map((transaction, index) => (
            <div key={index} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px',
              background: 'white',
              borderRadius: '6px',
              marginBottom: '10px',
              borderLeft: `3px solid ${transaction.type === 'income' ? '#28a745' : '#dc3545'}`
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: transaction.type === 'income' ? '#d4edda' : '#f8d7da',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px'
                }}>
                  {transaction.type === 'income' ? '↓' : '↑'}
                </div>
                <div>
                  <div style={{ fontWeight: '500', marginBottom: '3px' }}>
                    {transaction.description}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    {new Date(transaction.date).toLocaleDateString('en-US', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric'
                    })}
                  </div>
                </div>
              </div>
              <div style={{
                fontSize: '16px',
                fontWeight: 'bold',
                color: transaction.type === 'income' ? '#28a745' : '#dc3545'
              }}>
                {transaction.type === 'income' ? '+' : '-'}₹{parseFloat(transaction.displayAmount).toFixed(2)}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default TransactionHistory;